import {uniqueId} from 'lodash'

const columns = [
  {
    title: 'Nickname',
    prop: 'username',
    type: 'text'
  },
  {
    title: 'Phone number',
    prop: 'phone',
    type: 'text'
  },
  {
    title: 'Email',
    prop: 'email',
    type: 'text'
  }
]

const prefix = 'user_form_column_'
const userFormColumns = columns.map(col => {
  col.id = uniqueId(prefix)
  return col
})

export default userFormColumns



// WEBPACK FOOTER //
// ./src/constants/Forms/userForm.js